module.exports = __webpack_public_path__ + "img/infografica-img-01.0f2a8ff1.png";